import React, { useEffect, useState } from "react";
import Head from "next/head";
import Router, { useRouter } from "next/router";
import NavigationBar from "./Navbar/NavigationBar";
import Footer from "./Footer/Footer";
import Variables from "./styles/variables";
import Fonts from "./styles/font";
import Global from "./styles/global";
import {
  HEADER_DEFAULT,
  HEADER_EXTERNAL,
  HEADER_NONE,
  FOOTER_DEFAULT,
  FOOTER_EXTERNAL,
  FOOTER_NONE
} from "../utils/constanta";
import NavbarExternal from "./Navbar/NavbarExternal";
import ButtonWhatsapp from "./ButtonWhatsapp/ButtonWhatsapp";
import FooterExternal from "./Footer/FooterExternal";
import { inIframe } from "../utils/helpers";

//refer to constanta
const HeaderModel = [
  {
    type: HEADER_DEFAULT,
    component: <NavigationBar />
  },
  {
    type: HEADER_EXTERNAL,
    component: <NavbarExternal />
  },
  {
    type: HEADER_NONE,
    component: <> </>
  }
];

const FooterModel = [
  {
    type: FOOTER_DEFAULT,
    component: <Footer />
  },
  {
    type: FOOTER_EXTERNAL,
    component: <FooterExternal />
  },
  {
    type: FOOTER_NONE,
    component: <> </>
  }
];

const HeaderFactory = (type) => {
  const header = HeaderModel.filter((obj) => {
    return obj.type === type;
  });

  return header[0] && header[0].component
    ? header[0].component
    : HeaderModel[0].component;
};

const FooterFactory = (type) => {
  const footer = FooterModel.filter((obj) => {
    return obj.type === type;
  });

  return footer[0] && footer[0].component
    ? footer[0].component
    : FooterModel[0].component;
};

type LayoutProps = {
  children?: any;
  error?: string;
  height?: string;
  mobileHeight?: string;
  headerTypeProps?: string;
  footerTypeProps?: string;
};

const Layout = ({
  children,
  error,
  height,
  headerTypeProps = HEADER_DEFAULT,
  footerTypeProps = FOOTER_DEFAULT,
  mobileHeight
}: LayoutProps) => {
  const [headerType, setHeaderType] = useState(headerTypeProps);
  const [footerType, setFooterType] = useState(footerTypeProps);
  const [showLC, setShowLC] = useState(false);

  useEffect(() => {
    if (error) {
      Router.push({
        pathname: "/"
      });
    }
  }, [error]);

  useEffect(() => {
    //cek is in iframe then apply header none

    if (inIframe()) {
      setHeaderType(HEADER_NONE);
      setFooterType(FOOTER_DEFAULT);
    }
  });

  useEffect(() => {
    //to set header and footer from props change (like in slik)
    if (headerType !== headerTypeProps) setHeaderType(headerTypeProps);
    if (footerType !== footerTypeProps) setHeaderType(footerTypeProps);
  }, [headerTypeProps, footerTypeProps]);

  const router = useRouter();
  const asPath = router.asPath;

  useEffect(() => {
    if (
      asPath === "/info/pengkinian-data-pelanggan" ||
      asPath === "/info/upload-kuitansi"
    ) {
      setShowLC(true);
    } else {
      setShowLC(false);
    }
  }, [showLC]);

  return (
    <React.Fragment>
      {showLC && (
        <Head>
          <link
            id="genesys-cx-widget-styles"
            type="text/css"
            rel="stylesheet"
            href="/livechathcid/widgets.min_beauty.css"
          />
          <script
            async
            id="genesys-cx-widget-script"
            src="/livechathcid/widgets.min.js"
          />

          <script
            async
            dangerouslySetInnerHTML={{
              __html: `
                          var path = window.location.pathname;
                          var page = path==="/info/pengkinian-data-pelanggan"||path==="/info/upload-kuitansi"
                if(!window._genesys)window._genesys = {};
                        if(!window._gt)window._gt = [];

                window._genesys.widgets = {
                      main: {
                            debug: page,
                            theme: "light",
                            lang: "en",
                            customStylesheetID: "genesys_widgets_custom",
                            plugins: [
                                  "cx-webchat",
                                  "cx-webchat-service"
                            ]
                      },
                      webchat: {
                            dataURL: "https://livechat.homecredit.co.id/genesys/2/chat/customer-support",
                            apikey: "",
                            userData: {},
                            autoInvite: {
                                  enabled: false,
                                  timeToInviteSeconds: 5,
                                  inviteTimeoutSeconds: 30
                            },
                            chatButton: {
                                  enabled: page,
                                  openDelay: 1000,
                                  effectDuration: 300,
                                  hideDuringInvite: true
                            },
                            uploadsEnabled: true
                      }
                };

                        (function(o){
                  var f = function(){
                    var d = o.location;
                    o.aTags = o.aTags || [];
                    for(var i=0;i<o.aTags.length;i++){
                      var oTag = o.aTags[i];
                      var fs = d.getElementsByTagName(oTag.type)[0], e;
                      if(d.getElementById(oTag.id)) return; e = d.createElement(oTag.type); e.id = oTag.id;
                      if(oTag.type == "script"){e.src = oTag.path;}
                                        else{e.type = 'text/css';e.rel = 'stylesheet';e.href = oTag.path;}
                      if(fs){fs.parentNode.insertBefore(e, fs);}else{d.head.appendChild(e);}
                    }},ol = window.onload;
                    if(o.onload){typeof window.onload != "function"?window.onload=f:window.onload=function(){ol();f();}}else f();
                })({location: document,
                    onload: false,
                    aTags: [{type:"script", id:"genesys-cx-widget-script", path:"https://web-preprod.homecredit.co.id/livechathcid/widgets.min.js"},
                    {type:"link", id:"genesys-cx-widget-styles", path:"https://web-preprod.homecredit.co.id/livechathcid/widgets.min_beauty.css"}]});
                    `
            }}
          />
        </Head>
      )}
      <Variables />
      <Fonts />
      <Global />
      <noscript>
        <iframe
          src="//www.googletagmanager.com/ns.html?id=GTM-T97TWZD"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
      {HeaderFactory(headerType)}
      <div className="main-container">{children}</div>
      {!showLC && <ButtonWhatsapp />}
      {FooterFactory(footerType)}
      <style jsx global>{`
        * {
          margin: 0;
          padding: 0;
        }
        h2 {
          margin-block-start: 0.83em;
          margin-block-end: 0.83em;
        }
        .main-container {
          display: flex;
          flex-direction: column;
          min-height: ${height ? height : "100vh"};
        }
        @media only screen and (max-width: 600px) {
          .main-container {
            min-height: ${mobileHeight ? mobileHeight : "100vh"};
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default Layout;
